export function locationConfig($locationProvider) {
    'ngInject';
    
    $locationProvider.hashPrefix('');
} 
